import { createSelector } from 'reselect'
import { curry } from 'lodash'
import { selectFromAll } from 'src/store/selectors/home/dictionary'
import { selectCurrentAVM } from 'src/store/selectors/home/avm'
import { selectCELsOutstandingPrincipal } from 'src/store/selectors/home/loans'
import {
  avgSellingCostPercent,
  lowFeePercent,
  highFeePercent
} from 'src/constants/equity'

const avgAmericanExpenses6Months = 23000
const monthsInAYear = 12

export const getLeverageableEquityForLTV = curry(
  (ltv, avm, balance) => avm * ltv - balance
)

export const selectLeverageableEquityForLTV = ltv =>
  createSelector(
    selectCurrentAVM,
    selectCELsOutstandingPrincipal,
    getLeverageableEquityForLTV(ltv)
  )

export const selectTotalEquity = selectLeverageableEquityForLTV(1)
export const selectLeverageableEquityForLTV_80 = selectLeverageableEquityForLTV(
  0.8
)

const selectExistingMonthlyPayment = selectFromAll('monthlyPaymentTotal')

export const selectEmergencyReserveTarget = createSelector(
  selectExistingMonthlyPayment,
  payment => payment * monthsInAYear || avgAmericanExpenses6Months
)

export const selectSellingCost = feePercent =>
  createSelector(
    selectCurrentAVM,
    avm => avm * feePercent
  )

export const selectLowFees = selectSellingCost(lowFeePercent)
export const selectHighFees = selectSellingCost(highFeePercent)

export const selectCashFromSale = createSelector(
  selectTotalEquity,
  selectSellingCost(avgSellingCostPercent),
  (totalEquity, sellingCost) => totalEquity - sellingCost
)

export const asDownPaymentPercent = curry(
  (percent, downpayment) => downpayment / percent
)

export const selectAddSpaceBudget = selectLeverageableEquityForLTV_80
export const selectNewInvestmentBudget = selectLeverageableEquityForLTV_80
export const selectHomeImprovementBudget = selectLeverageableEquityForLTV_80
